import React, {PureComponent} from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper/index'
import {TableComp} from 'sz-react-utils'
// import GetAllFormFields from '../../../components/_utils/formUtils'
import {Button, Card, Form,Row,Col, DatePicker, Tooltip, notification} from 'antd'
import _ from 'lodash'
import ApplyLeave from '../../components/_utils/leaveapplication';
import Request from '../../request'
import {connect} from 'react-redux'
import moment from 'moment'


const {MonthPicker} = DatePicker
@Form.create()
class LeaveApplication extends PureComponent {
    state = {
        count: 0,
        month:moment(),
        defaultPageSize: 20,
        oldLeaves:[],
        showApplicationForm:false,
        sandwichLeaves:0,
        casualLeaves:0,
        leavesWithoutPay:0,
        leavesWithoutNotice:0,
        shortLeaves:0
    }



    refreshFxn = () => {
        this.setState({refreshChild: !this.state.refreshChild})
    }

    handleLeaveWithDrawal = async (data) =>{
        data.status = "Withdrawn"
        data.leaveType = ''
        let response = await Request.updateStaffLeave(data);
        if(!response.error) {
            notification.success({
                message:response.msg
            })
            this.reload()
        }else {
            notification.error({
                message:response.msg
            })
        }
    }
    async getLeaveDetails() {
        let currentUser = JSON.parse(localStorage.getItem('user'));
            let sandwichLeaveDetails = await this.getSandwichLeaveDetails(currentUser._id);
            let casualLeaveDetails = await this.getCasualLeaveDetails(currentUser._id);
            let leaveWithoutPayDetails = await this.getLeaveWithoutPayDetails(currentUser._id);
            let leaveWithoutNoticeDetails = await this.getLeaveWithoutNoticeDetails(currentUser._id)
            let shortLeave = await this.getShortLeaveDetails(currentUser._id)
            this.setState({sandwichLeaves:sandwichLeaveDetails.total, casualLeaves:casualLeaveDetails.total,leavesWithoutPay:leaveWithoutPayDetails.total, leavesWithoutNotice:leaveWithoutNoticeDetails.total, shortLeaves:shortLeave.total })
    }

    async getSandwichLeaveDetails (userId) {
        let data = {
            userId:userId,
            leaveType:'Sandwich Leave',
            leaveYear:moment(this.state.month).format('YYYY'),
            status:"Approved"
        }
        
        let response = await Request.getUserLeaves(data);
        return response
    }
    async getCasualLeaveDetails(userId) {
        let data = {
            userId:userId,
            leaveType:'CL(Casual Leave)',
            leaveYearMonth:moment(this.state.month).format('YYYY-MM'),
            status:'Approved'
        }
        let response = await Request.getUserLeaves(data);
        return response
    }

    async getLeaveWithoutPayDetails(userId) {
        let data = {
            userId:userId,
            leaveType:'LWP(Leave Without Pay)',
            leaveYearMonth:moment(this.state.month).format('YYYY-MM'),
            status:'Approved'
        }
        let response = await Request.getUserLeaves(data);
        return response
    }

    async getLeaveWithoutNoticeDetails(userId) {
        let data = {
            userId:userId,
            leaveType:'LWN(Leave Without Notice)',
            leaveYearMonth:moment(this.state.month).format('YYYY-MM'),
            status:'Approved'
        }
        let response = await Request.getUserLeaves(data);
        return response
    }

    async getShortLeaveDetails(userId) {
        let data = {
            userId:userId,
            leaveType:'HD(Half Day)',
            leaveYearMonth:moment(this.state.month).format('YYYY-MM'),
            status:'Approved'
        }
        let response = await Request.getUserLeaves(data);
        return response
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    handleApplicationClick = () =>{
        this.setState({showApplicationForm:true})
    }

    handleApplicationClose = () =>{
        this.setState({showApplicationForm:false})
        this.table.current.reload()
    }

    apiRequest = params =>{
        return new Promise(async(resolve)=>{
            params.month = this.state.month
            let response = await Request.getLeaveApplications(params);
            this.setState({count:response.total, oldLeaves:response.data})
            resolve(response)
        })
    }

    handleMonthChange = (month) =>{
        this.setState({month:moment(month)}, ()=>{
            this.reload()
        })
    }

    reload = () =>{
        this.table.current.reload()
    }

    componentDidMount() {
        this.getLeaveDetails();
    }

    render() {
        const {defaultPageSize, showApplicationForm, count, oldLeaves, sandwichLeaves,casualLeaves, leavesWithoutPay, leavesWithoutNotice} = this.state
        const columns = [
            {
                title: 'Start Date',
                key: 'startDate',
            },
            {
                title: 'Start Time',
                key: 'startTime',
            },
            {
                title: 'End Date',
                key: 'endDate',
            },
            {
                title:'End Time',
                key:'endTime',
            },
            {
                title:'Leave Duration',
                key:'leaveDuration',
                render:(text,record) => (
                    <div>
                        {record.leaveDuration?record.leaveDuration >1?<span>{text} Days</span>:<span>{text} Day</span>:null}
                    </div>
                )
            },
            {
                title:'Leave Type',
                key:'leaveType'
            },
            {
                title:'Approved/Disapproved By',
                key:'updatedByUser.name',
                render:(text,record)=>{
                    if(record.status === 'Approved' || record.status === "Disapproved") {
                        return (
                            <div>{record.updatedByUser && record.updatedByUser.name}</div>
                        )
                    }
                }
            },
            {
                title:'Status',
                key:'status',
                render:(text,record)=>{
                    if(text === 'Approved') {
                        return (
                            <div style={{background:'#2C6E49', color:'white'}}>{text}</div>  //green
                        )
                    }else if(text === 'Disapproved') {
                        return (
                            <div style={{background:'#ed1d24', color:'white'}}>{text}</div>
                        )
                    }else {
                        return(
                            <div style={{background:'#FCF55F'}}>{text}</div>
                        )
                    }
                }
            },
            {
                title:'Action',
                key:'operation',
                dataIndex:'operation',
                render:(text,record) => {
                    let dateIsAfter = moment().startOf('day').isAfter(moment(record.startDate))
                    return (
                        <React.Fragment>
                        {record.status === "Pending" || record.status === "Approved" && !dateIsAfter ?
                        <Tooltip title="WithDraw Leave Application">
                            <Button
                            size={"small"}
                            shape="circle"
                            onClick={() => this.handleLeaveWithDrawal(record)}
                            icon="cross"
                            />
                        </Tooltip>
                        :null}
                    </React.Fragment>
                    )
                }
            }
        ]


        return (
           <PageHeaderWrapper title={`Leave Applications:- ${count}` }>
            {
                showApplicationForm?
                    <ApplyLeave oldLeaves={oldLeaves} onClose={this.handleApplicationClose} />
                :null
            }
                <Card bordered={true}>
                    <Row style={{display:'flex'}}>
                        <Col >
                            <label>Search By Month</label><br />
                            <MonthPicker placeholder='Select Month' defaultValue={moment(this.state.month, 'YYYY-DD')} format="YYYY-MM" onChange={this.handleMonthChange} />
                        </Col>
                        <Col >
                            <div style={{textAlign: 'right', marginTop: '15px'}}>
                                <Button onClick={this.handleApplicationClick} >Apply Leave </Button>
                            </div>
                        </Col>

                        <Col  style={{marginLeft:'30px' ,textAlign:'center', fontWeight:'600'}}>
                            <div style={{background:'#2C6E49', padding:'5px', marginTop:'1px', color:'white', borderRadius:'0.8rem'}}>Casual Leaves:- {casualLeaves}</div>
                            <div style={{background:'#FCF55F', padding:'5px', marginTop:'2px', borderRadius:'0.8rem'}}>Leave Without Pay:- {leavesWithoutPay}</div>
                        </Col>
                        <Col  style={{marginLeft:'30px' ,textAlign:'center', fontWeight:'600'}}>
                            <div style={{background:'#ed1d24', color:'white', padding:'5px', marginTop:'1px',  borderRadius:'0.8rem'}}>Leave Without Notice:- {leavesWithoutNotice}</div>
                            <div style={{background:'#0050B5', color:'white', padding:'5px', marginTop:'2px',  borderRadius:'0.8rem'}}>Sandwich Leaves:- {sandwichLeaves}/2</div>
                        </Col>
                        <Col  style={{marginLeft:'30px', textAlign:'center', fontWeight:'600'}}>
                            <div style={{background:'#ed1d24', color:'white', padding:'5px', marginTop:'1px',  borderRadius:'0.8rem'}}>Disapproved</div>
                            <div style={{background:'#2C6E49', color:'white', padding:'5px', marginTop:'2px',  borderRadius:'0.8rem'}}>Approved</div>
                        </Col>
                    </Row>
                </Card>
                <Card bordered={true} >
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        extraProps={{scroll: {x: 900}}}
                        pagination={{
                        showSizeChanger: true,
                        defaultPageSize: defaultPageSize,
                        pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                 </Card>
           </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LeaveApplication)
